'use client';

import { useEffect } from 'react';

import { LoaderOverlay } from '@/components/ui/loader';
import { useAuth } from '@/hooks/useAuth';

export function AuthProvider({ children }: { children: React.ReactNode }) {
    const { isInitializing, initializeAuth } = useAuth();

    useEffect(() => {
        initializeAuth();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isInitializing) {
        return (
            <LoaderOverlay
                text="Please wait..."
                className="fixed inset-0 z-[100]"
            />
        );
    }

    return <>{children}</>;
}

